import { combineReducers } from "redux";
import customerSatisfactionSubmitForm from  './customerSatisfactionSubmitForm'

export const customerSatisfactionSurvey = combineReducers({
    customerSatisfactionSubmitForm
});
